module.exports = __webpack_public_path__ + "img/collect_ny_icon_alt@2x.30185c71.png";